<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="1000"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Row :gutter="16">
                    <Col span="8">
                        <FormItem label="姓名：" prop="real_name">
                            <Input v-model="Forms.real_name" placeholder="请输入" />
                        </FormItem>
                    </Col>
                    <Col :span="8">
                        <FormItem label="公司名：" prop="company">
                            <Input v-model="Forms.company" placeholder="请输入" />
                        </FormItem>
                    </Col>
                    <Col :span="8">
                        <FormItem label="统一社会信用代码：" prop="code">
                            <Input v-model="Forms.code" placeholder="请输入" />
                        </FormItem>
                    </Col>
                    <Col :span="8">
                        <FormItem label="联系人：" prop="contact_name">
                            <Input v-model="Forms.contact_name" placeholder="请输入" />
                        </FormItem>
                    </Col>
                    <Col :span="8">
                        <FormItem label="联系人电话：" prop="contact_mobile">
                            <Input v-model="Forms.contact_mobile" placeholder="请输入" />
                        </FormItem>
                    </Col>
                    <Col :span="8">
                        <FormItem label="身份证号：" prop="contact_card">
                            <Input v-model="Forms.contact_card" placeholder="请输入" />
                        </FormItem>
                    </Col>
                    <Col :span="8">
                        <FormItem label="银行账号：" prop="bank_account">
                            <Input v-model="Forms.bank_account" placeholder="请输入" />
                        </FormItem>
                    </Col>
                    <Col :span="8">
                        <FormItem label="开户银行：" prop="bank_name">
                            <Input v-model="Forms.bank_name" placeholder="请输入" />
                        </FormItem>
                    </Col>
                    <Col :span="8">
                        <FormItem label="入职时间" prop="job_time">
                            <DatePicker type="date" format="yyyy-MM-dd" v-model="Forms.job_time" placeholder="入职时间" class="width-100"  />
                        </FormItem>
                    </Col>
                    <Col :span="8">
                        <FormItem label="联系地址" prop="contact_address">
                            <Input v-model="Forms.contact_address" placeholder="请输入" />
                        </FormItem>
                    </Col>
                    <Col :span="8">
                        <FormItem label="家庭地址" prop="address">
                            <Input v-model="Forms.address" placeholder="请输入" />
                        </FormItem>
                    </Col>
                    <Col :span="8">
                        <FormItem label="状态：">
                            <RadioGroup v-model="Forms.status" type="button">
                                <Radio :label="1">审核</Radio>
                                <Radio :label="2">禁用</Radio>
                                <Radio :label="3">开启</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                    <Col :span="24">
                        <FormItem label="备注信息" prop="remark">
                            <Input v-model="Forms.remark" type="textarea" :rows="4" clearable placeholder="" />
                        </FormItem>
                    </Col>
                    <Divider orientation="left">资料信息</Divider>
                    <Col :span="24">
                        <template v-for="(item, index) in Forms.certList" :key="index">
                        <Row :gutter="16">
                            <Col :span="6">
                                <FormItem label="资料名称" :prop="'certList.' + index + '.title'" :rules="{required: true, message: '必填', trigger: 'blur'}">
                                    <Input v-model="item.title" placeholder="请输入" />
                                </FormItem>
                            </Col>
                            <Col :span="8">
                                <FormItem label="文件" :prop="'certList.' + index + '.file'" :rules="{required: true, message: '必填', trigger: 'blur'}">
                                    <Input v-model="item.file" disabled class="width-100" >
                                        <template #append>
                                            <div class="f-center">
                                                <Upload
                                                    :show-upload-list="false"
                                                    :action="upload_url"
                                                    :headers = "{'token': $store.state.token}"
                                                    :format="['xls','xlsx','rar','zip','doc','docx','txt','docx','jpg','jpeg','png','pdf']"
                                                    :max-size="50 * 1024"
                                                    :on-success="handleSuccess"
                                                    :on-format-error="handleFormatError"
                                                    :on-exceeded-size="handleMaxSize">
                                                    <a href="javascript:void(0);" class="text-primary" @click="toUpload(index)"><Icon type="md-cloud-upload" />上传</a>
                                                </Upload>
                                                <Divider type="vertical" />
                                                <a href="javascript:void(0);" @click="FileDelete(index)" class="text-danger"><Icon type="md-trash" />删除</a>
                                                <Divider type="vertical" />
                                                <a href="javascript:void(0);" @click="FileDownload(item.file)" class="text-violet"><Icon type="md-download" />下载</a>
                                            </div>
                                        </template>
                                    </Input>
                                </FormItem>
                            </Col>
                            <Col :span="4">
                                <FormItem label="到期时间" :prop="'certList.' + index + '.end_time'">
                                    <DatePicker type="date" format="yyyy-MM-dd" v-model="item.end_time" placeholder="到期时间" class="width-100"  />
                                </FormItem>
                            </Col>
                            <Col :span="4">
                                <FormItem label="是否提醒：" :prop="'certList.' + index + '.is_alert'">
                                    <RadioGroup v-model="item.is_alert" type="button">
                                        <Radio :label="1">提醒</Radio>
                                        <Radio :label="2">不提醒</Radio>
                                    </RadioGroup>
                                </FormItem>
                            </Col>
                            <Col :span="2">
                                <FormItem label="操作">
                                    <a href="javascript:void(0);" @click="deleteCert(index)" class="text-danger">删除</a>
                                </FormItem>
                            </Col>

                        </Row>
                        </template>
                    </Col>
                    <Col :span="24">
                        <Button type="primary" @click="addCert()"><Icon type="md-add" /> 添加资料</Button>
                    </Col>

                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button style="margin-right: 8px" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">保存</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {getCertConfig, getCertDetail, saveCert} from "@/apis/cert";

export default {
    name: 'Create',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '新增证书',
            isBox : false,
            typeList : [],
            Forms : {
                id:'',
                real_name: '',
                company: '',
                code: '',
                contact_name: '',
                contact_mobile: '',
                contact_card: '',
                bank_account: '',
                bank_name: '',
                job_time: '',
                contact_address: '',
                address: '',
                status: 3,
                remark: '',
                certList: []
            },
            Rules : {
                real_name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                ]
            },

            upload_url : this.$uploadFileApi,
            site_url : this.$siteApi,
            onIndex : -1,
        }
    },
    methods: {
        addCert(){
            let that = this;
            that.Forms.certList.push({
                id: '',
                title: '',
                file: '',
                end_time: '',
                is_alert: 2
            });
        },
        deleteCert(index){
            let that = this;
            that.Forms.certList.splice(index , 1);
        },
        /**
         功能：获取详情
         time: 2025-53-02 10:53:04
         **/
        GetDetail(id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getCertDetail(id).then(e => {
                let data = e.data;
                for (let v of Object.keys(that.Forms)) {
                    if(v === 'status') {
                        that.Forms[v] = parseInt(data[v]);
                    }else if(v === 'certList'){
                        that.Forms[v] = data[v] ?? [];
                    }else{
                        that.Forms[v] = data[v];
                    }
                }
            })
        },
        /**
         功能：图片文件
         time: 2025/12/17 10:48
         **/
        FileDelete(index){
            let that = this;
            that.Forms.certList[index].file = "";
        },
        toUpload(index){
            this.onIndex = index;
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleSuccess(res){
            let that = this;
            if(res.code === 100){
                this.Forms.certList[this.onIndex].file = res.data.url;
                this.onIndex = -1;
            }else{
                that.$Message.error({ background: true,duration:3, content: res.msg});
            }
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleFormatError(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '只支持 PDF | xls | xlsx | rar | zip | doc | docx | txt | jpg | jpeg | png 文件 ' });
            return false;
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleMaxSize(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '文件大小不能超出 50M' });
            return false;
        },
        /**
         功能：
         time: 2025/12/19 18:12
         **/
        FileDownload(url){
            let that = this;
            if(url){
                //下载文件
                const fileUrl = that.site_url + url; // 文件的URL地址
                const parts = fileUrl.split('/');
                const fileName = parts[parts.length - 1];
                const link = document.createElement('a');
                link.href = fileUrl;
                link.target = '_blank';
                link.setAttribute('download', fileName);
                link.click();
            }else{
                that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
            }
        },
        /**
         功能：
         time: 2026/1/5 14:49
         **/
        GetConfig(){
            let that = this;
            getCertConfig().then(e=>{
                that.typeList = e.data.typeList ?? [];
            })
        },
        /**
         功能：添加
         time: 2025-52-02 10:52:34
         **/
        add(){
            this.isBox = true;
            this.GetConfig();
        },
        /**
         功能：编辑
         time: 2025-52-02 10:52:42
         **/
        edit(id){
            this.isBox = true;
            this.title = '编辑证书';
            this.GetConfig();
            if(id) this.GetDetail(id);
        },
        /**
         功能：
         time: 2025-55-02 10:55:40
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    saveCert(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025-55-02 10:55:45
         **/
        FormReset(){
            this.isBox = false;
            this.title = '新增证书';
            this.$refs['Forms'].resetFields();
            this.Forms.id = '';
            this.Forms.certList = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
.forms {
    .ivu-form-item {
        //margin-bottom: 0 !important;
    }
}
.spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.spin-text {
    font-size: 12px;
    padding-top: 10px;
}
</style>
